import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IWebBranch } from "../webBranchModel";

export const getAllWebBranches = createAsyncThunk(
  "WebsiteBranch/FindAllWebsiteBranch",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebsiteBranch/FindAllWebsiteBranch`,
        {
          BranchName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Branches:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createWebBranch = createAsyncThunk(
  "WebsiteBranch/InsertWebsiteBranch",
  async (WebBranchData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebsiteBranch/InsertWebsiteBranch`,
        WebBranchData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating branch:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateWebBranch = createAsyncThunk(
  "WebsiteBranch/UpdateWebsiteBranch",
  async (WebBranchData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebsiteBranch/UpdateWebsiteBranch`,
        WebBranchData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating branch :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteWebBranch = createAsyncThunk(
  "WebsiteBranch/DeleteWebsiteBranch",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebsiteBranch/DeleteWebsiteBranch`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting branch :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getWebBranchByID = createAsyncThunk(
  "WebsiteBranch/FindByIDWebsiteBranch",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebsiteBranch/FindByIDWebsiteBranch`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        BranchName: result?.BranchName,
        EmailID: result?.EmailID,
        Address: result?.Address,
        CityID: result?.CityID,
        MobileNo: result?.MobileNo,
        MapURL: result?.MapURL,
        WorkingHours: result?.WorkingHours,
        IsActive: result.IsActive ? 1 : 2,
      } as IWebBranch;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching branch :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveWebBranches = createAsyncThunk(
  "WebsiteBranch/FindAllActiveWebsiteBranch",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/WebsiteBranch/FindAllActiveWebsiteBranch`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Branches:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveWebBranch = createAsyncThunk(
  "WebsiteBranch/ActiveInActiveWebsiteBranch",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebsiteBranch/ActiveInActiveWebsiteBranch`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive branch :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
